const project = process.env.REACT_APP_PROJECT_TYPE;

export const RoutesGs = {
  //GOALCARDS PROJECT
  SendInvitation: '/sendinvitation',
  SuccessInvitation: '/sentsuccess',
  SendGift: '/gift',
  SelectGoalcard: '/selectgoalcard',
  CustomizeGoalcard: '/customize',
  PurchaseGoalcard: '/purchase',
  SuccessGoalcard: '/success',

  //USER PROJECT
  UserGoalShare: '/user/:userName/:goalName/share',
  UserShare: '/user/:userName/share',
  UserGoalId: '/user/:userName/:goalName',
  UserId: '/user/:userName',
  GoalcardAnimation:
    project === 'portal'
      ? '/anim/viewgcanimated.aspx'
      : '/user/anim/viewgcanimated.aspx',
  /**@deprecated */
  ViewGoalcard: '/viewgoalcard',
  /**@deprecated */
  GoalcardId: '/goalcard/:code',
  /**@deprecated */
  Goalcard: '/goalcard',

  ForgotPassword:
    project === 'portal' ? '/forgotpassword' : '/user/forgotpassword',
  ResetPassword:
    project === 'portal' ? '/resetpassword' : '/user/resetpassword',
  SuccessPassword:
    project === 'portal' ? '/successpassword' : '/user/successpassword',
};
